import { z } from "zod";
import { createCustomSettings } from "@rootreeweb/zod-to-elements";
export const leadSource = z
    .union([
    z.literal("Web"),
    z.literal("Trade Show"),
    z.literal("External Referral"),
    z.literal("Other"),
    z.literal("Ad"),
    z.literal("Social Media"),
    z.literal("Solicitation"),
    z.literal("CHFA Connect"),
    z.literal("RT Foundation 2021"),
    z.literal("Dormant Client Activation"),
    z.literal("Grocery Store"),
    z.literal("CTAQ 2022"),
    z.literal("Specialty Coffee Expo 2022"),
    z.literal("CHFA West 2022"),
    z.literal("SIAL 2022"),
    z.literal("Seed To Shelf"),
    z.literal("Beanstock 2022"),
    z.literal("CHFA Toronto 2022"),
    z.literal("Natural Products Expo East 2022"),
    z.literal("RT Foundation 2022"),
    z.literal("PLMA 2022"),
    z.literal("OOAK 2022"),
    z.literal("Stock Bag Clearance Campaign"),
    z.literal("Pillow Pouch Launch"),
    z.literal("Pouch Collective"),
    z.literal("CHFA Vancouver 2023"),
    z.literal("Specialty Coffee Expo 2023"),
    z.literal("SIAL Toronto 2023"),
    z.literal("Downtown Milton Summer Fest"),
    z.literal("Bala Cranberry Festival 2023"),
    z.literal("RT Staff Referral"),
    z.literal("CHFA Toronto 2023"),
    z.literal("Natural Products Expo East 2023"),
    z.literal("CHFA West Vancouver 2024"),
    z.literal("Access Labels"),
    z.literal("SIAL 2024"),
    z.literal("CHFA Toronto 2024"),
    z.literal("VENTUREPARK 2024 Toronto"),
    z.literal("CHFA Vancouver 2025"),
    z.literal("SIAL Toronto 2025"),
])
    .describe(createCustomSettings({ label: "Lead Source" }));
//# sourceMappingURL=lead-source-list.js.map